import { createFileRoute } from "@tanstack/react-router";

import { MethodologyPage } from "../components/methodology/MethodologyPage";
import { methodologyHead } from "../lib/methodology/head";
import { loadMethodology } from "../lib/methodology/index";
import { documentHeaders } from "../lib/seo";

/** `/methodology`, in English. */
export const Route = createFileRoute("/methodology")({
  loader: () => loadMethodology("en"),
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData ? methodologyHead("en", loaderData) : {},
  component: EnglishMethodology,
});

function EnglishMethodology() {
  return <MethodologyPage lang="en" copy={Route.useLoaderData()} />;
}
